export default `
  query getCategoryURLById($filters: CategoryFilterInput, $is_preview: Boolean = false) {
    categories(filters: $filters, is_preview: $is_preview) {
      items {
        url_path
      }
    }
  }
`;
